import { Injectable, Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "sportsTitleCase",
  standalone: true,
})
@Injectable({ providedIn: "root" })
export class SportsTitleCasePipe implements PipeTransform {
  transform(value: string, CountryCode?: string): string {
    if (!value) {
      return;
    }
    if (CountryCode === "US" || CountryCode === "US2") {
      return value;
    }
    return value
      .split(" ")
      .reduce((acc, value) => {
        return (acc += " " + value.charAt(0).toUpperCase() + value.slice(1).toLowerCase());
      }, "")
      .trim();
  }
}
